/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ComparisonsControllerGetByIdQueryResponse, ComparisonsControllerGetByIdPathParams, ComparisonsControllerGetById400, ComparisonsControllerGetById401, ComparisonsControllerGetById403, ComparisonsControllerGetById404 } from "../../models/comparisonsController/ComparisonsControllerGetById";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { comparisonsControllerGetById } from "../../clients/comparisonsService/comparisonsControllerGetById";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const comparisonsControllerGetByIdQueryKey = (id: ComparisonsControllerGetByIdPathParams["id"]) => [{
  url: '/api/v1/comparisons/:id',
  params: {
    id: id
  }
}] as const;
export type ComparisonsControllerGetByIdQueryKey = ReturnType<typeof comparisonsControllerGetByIdQueryKey>;
export function comparisonsControllerGetByIdQueryOptions(id: ComparisonsControllerGetByIdPathParams["id"], config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = comparisonsControllerGetByIdQueryKey(id);
  return queryOptions<ComparisonsControllerGetByIdQueryResponse, ResponseErrorConfig<ComparisonsControllerGetById400 | ComparisonsControllerGetById401 | ComparisonsControllerGetById403 | ComparisonsControllerGetById404>, ComparisonsControllerGetByIdQueryResponse, typeof queryKey>({
    enabled: !!id,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return comparisonsControllerGetById(id, config);
    }
  });
}

/**
 * @description Returns the full comparison record by its id.
 * @summary Get comparison by ID
 * {@link /api/v1/comparisons/:id}
 */
export function useComparisonsControllerGetById<TData = ComparisonsControllerGetByIdQueryResponse, TQueryData = ComparisonsControllerGetByIdQueryResponse, TQueryKey extends QueryKey = ComparisonsControllerGetByIdQueryKey>(id: ComparisonsControllerGetByIdPathParams["id"], options: {
  query?: Partial<QueryObserverOptions<ComparisonsControllerGetByIdQueryResponse, ResponseErrorConfig<ComparisonsControllerGetById400 | ComparisonsControllerGetById401 | ComparisonsControllerGetById403 | ComparisonsControllerGetById404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? comparisonsControllerGetByIdQueryKey(id);
  const query = useQuery({
    ...comparisonsControllerGetByIdQueryOptions(id, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ComparisonsControllerGetById400 | ComparisonsControllerGetById401 | ComparisonsControllerGetById403 | ComparisonsControllerGetById404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}